export default "__VITE_ASSET__DqmFV3Qt__"